export const SET_IS_GALLERY_OPEN = 'galleryModal.SET_IS_GALLERY_OPEN';
export const SET_ACTIVE_INDEX = 'galleryModal.SET_ACTIVE_INDEX';
export const SET_GALLERY_TYPE = 'galleryModal.SET_GALLERY_TYPE';